import { Directive, Input, HostListener } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { NewsService } from '../../services/news.service';
import { AppConfig } from '../../app/app.config';
import * as $ from 'jquery';

//消息详情指令
//TQQ 2017-02-23
@Directive({ selector: '[msgdetail]' })
export class MsgDetailDirective {
    constructor(private modalctrl: ModalController) {
    }

    @Input("msgdetail") Data: any;

    @HostListener('click') onMouseEnter() {
        let modal = this.modalctrl.create(MsgDetailComponent, this.Data);
        // modal.onWillDismiss(s => {
        //     if (this.Data.msg.StateCode == "01" && $.isFunction(this.Data.callback)) {
        //         this.Data.callback();
        //     }
        // });
        modal.present();
    }

}


@Component({
    selector: 'msg-detail',
    templateUrl: 'msgdetail.html',
    providers: [NewsService]
})
export class MsgDetailComponent {
    constructor(
        private viewctrl: ViewController,
        private navparam: NavParams,
        private newsService: NewsService,
        private config: AppConfig
    ) { }

    msg = {
        Contect: "",
        ReceiveUserName: "",
        SendUserName: "",
        Title: "",
        StateCode: "",
        Id: 0
    };
    isReceive = true;//是否是收件箱

    //TQQ 2017-02-23
    ionViewDidLoad() {
        let username = this.config.getCurrentUser().UserName;
        this.msg = this.navparam.data.msg;
        this.isReceive = this.navparam.data.isReceive;
        if (this.msg.StateCode == "01") {
            this.newsService.read(this.msg.Id.toString(), username).then(s => {
                if ($.isFunction(this.navparam.data.callback)) {
                    this.navparam.data.callback();
                }
            }).catch(c => {
                throw c;
            });
        }

    }


    dismiss() {
        this.viewctrl.dismiss();
    }
}




// WEBPACK FOOTER //
// ./src/dires/msgdetail/msgdetail.diretive.ts